import React, { useState, useEffect, useRef } from "react";
import styles from "assets/scss/task_management.module.css";
import { FaTimes } from "react-icons/fa";
import { Trans } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const AddGroup = ({ isOpen, onClose, onSave, employees, group, selectedOrganisation, t }) => {
    const [groupName, setGroupName] = useState("");
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (group) {
            setGroupName(group.group_name);
            setSelectedEmployees(group.employees);
        }
    }, [group]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (!isOpen) {
            setGroupName('');
            setSelectedEmployees([]);
        }
    }, [isOpen]);


    if (!isOpen) return null;

    const handleSave = () => {
        const groupData = { 
            group_name: groupName, 
            employees: selectedEmployees,
            connected_organisation: selectedOrganisation.id,
            xero_organisation_id: selectedOrganisation.xero_organisation_id
        };

        onSave(group ? { ...group, ...groupData } : groupData);
        onClose();
    };

    const handleEmployeeSelect = (employeeId) => {
        if (!selectedEmployees.includes(employeeId)) {
            setSelectedEmployees([...selectedEmployees, employeeId]);
        }
    };

    const handleRemoveEmployee = (employeeId) => {
        setSelectedEmployees(selectedEmployees.filter(id => id !== employeeId));
    };

    const unselectedEmployees = employees.filter(employee => !selectedEmployees.includes(employee.id));

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="md">
            <ModalHeader toggle={onClose}>
                {group ? t("Update Group") : t("Add New Group")}
            </ModalHeader>
            <ModalBody>
                <div className={styles.modalContent}>
                    <label><Trans>Group name</Trans>*</label>
                    <input 
                        type="text" 
                        value={groupName} 
                        onChange={(e) => setGroupName(e.target.value)} 
                    />

                    {selectedEmployees?.length > 0 && (
                        <>
                            <div className={styles.assignedEmployees}><strong><Trans>Assigned Employees</Trans></strong></div>
                            {selectedEmployees.map(employeeId => (
                                <div key={employeeId} className={styles.assignedEmployee}>
                                    {employees.find(employee => employee?.id === employeeId)?.full_name} 
                                    <FaTimes onClick={() => handleRemoveEmployee(employeeId)} />
                                </div>
                            ))}
                        </>
                    )}
                    <label><Trans>Employee</Trans>*</label>

                    <div className={styles.notes_area}>
                        <input 
                            type="text" 
                            placeholder={t("Search Employees")}
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            className={styles.search_employee}
                            onFocus={() => setShowDropdown(true)}
                        />
                    </div>

                    {showDropdown && (
                        <div className={styles.dropdownContent} ref={dropdownRef}>
                            <div className={styles.suggestions}><strong><Trans>Suggestions</Trans></strong></div>
                            {unselectedEmployees ? unselectedEmployees
                                .filter(employee => employee?.full_name.toLowerCase().includes(searchKeyword.toLowerCase()))
                                .map((employee, index) => (
                                    <button
                                        key={index}
                                        className={styles.suggestion}
                                        onMouseDown={() => {
                                            handleEmployeeSelect(employee?.id);
                                            setSearchKeyword("");
                                        }}
                                    >
                                        {employee?.full_name}
                                    </button>
                                ))
                            : <div><Trans>No employees found</Trans></div>}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}><Trans>Cancel</Trans></Button>
                <Button color="primary" onClick={handleSave} disabled={!groupName || selectedEmployees.length === 0}>
                    <Trans>Save</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddGroup;
